module.exports = __webpack_public_path__ + "img/wheel.dc8c1aa4.png";